import { withStyles } from '@mui/styles';
import { Tabs as MuiTabs } from '@mui/material';

const styles = () => ({
    tabs: {
        minHeight: 'initial',
    },
});

function Tabs({ children, value, onChange, ariaLabel, classes, ...other }) {
    return (
        <MuiTabs
            value={value}
            onChange={onChange}
            aria-label={ariaLabel}
            className={classes.tabs}
            indicatorColor="transparent"
            variant="scrollable"
            scrollButtons={false}
            {...other}
        >
            {children}
        </MuiTabs>
    );
}

export default withStyles(styles)(Tabs);
